<template>
  <div :style="style.container">
    <div :style="style.top">
      <TextCardLabelPrimary :style="style.label">
        SKILL DETAIL
      </TextCardLabelPrimary>
      <CardPrimary :style="style.cardSkillDetail">
        <div>
          <TextMutedPrimary>
            {{ survey.name }} > {{ surveyCategoryName }}
          </TextMutedPrimary>
          <HeaderLargePrimary :style="style.header">
            {{ surveyCategorySkillName }}
          </HeaderLargePrimary>
        </div>
        <div :style="getDescriptionStyle">
          <TextRegular
            v-if="surveyCategorySkillDescription.length > 0"
            :usePreline="true"
          >
            {{ surveyCategorySkillDescription }}
          </TextRegular>
          <TextMutedPrimary v-else>
            No description available.
          </TextMutedPrimary>
        </div>
        <TagToggleListPrimary
          v-if="isOthers"
          v-model="categorizedTenantUserSkillIds"
          :items="tenantUserSkillItems"
          :style="style.tenantUserSkillTags"
          @select="onSelectTenantUserSkill"
          @unselect="onUnselectTenantUserSkill"
        />
        <div :style="style.buttonContainer">
          <div
            v-if="owned"
            :style="style.editButtonContainer"
          >
            <GoogleMaterialIconPrimary
              content="check"
            />
            <div :style="style.editText">
              You have this skill.
            </div>
            <TextButtonMuted
              :disabled="isPreview"
              :style="style.buttonFreeForm"
              @click="$emit('edit')"
            >
              Edit skill
            </TextButtonMuted>
          </div>
          <ButtonPrimary
            v-else
            :disabled="isPreview"
            @click="$emit('add', isOthers ? null : surveyCategorySkill.skill.name)"
          >
            {{ isOthers ? 'Add new skill' : 'Add to my skill' }}
          </ButtonPrimary>
        </div>
      </CardPrimary>
    </div>
  </div>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import GoogleMaterialIconPrimary
    from '@modules/v2/icon/google-material-icon-primary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import TagToggleListPrimary from '@modules/v2/tag/tag-toggle-list-primary'
  import TextButtonMuted from '@modules/v2/button/text-button-muted'
  import TextCardLabelPrimary from '@modules/v2/text/text-card-label-primary'
  import TextMutedPrimary from '@modules/v2/text/text-muted-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SkillDetail',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      CardPrimary,
      GoogleMaterialIconPrimary,
      HeaderLargePrimary,
      TagToggleListPrimary,
      TextButtonMuted,
      TextCardLabelPrimary,
      TextMutedPrimary,
      TextRegular,
    },
    props: {
      isPreview: {
        type: Boolean,
        required: false,
        default: false,
      },
      ownedSkillIds: {
        type: Array,
        required: false,
        default: () => [],
      },
      survey: {
        type: Object,
        required: false,
        default: () => {},
      },
      surveyCategorySkill: {
        type: Object,
        required: false,
        default: () => {},
      },
      surveyCategoryTenantUserSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
      tenantUserSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        categorizedTenantUserSkillIds: [],
        style: {
          buttonContainer: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'flex-end',
            margin: '40px 0 0 0',
            width: '100%',
          },
          cardSkillDetail: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '128px',
            padding: Layout.space.md,
            width: '100%',
          },
          container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '100%',
          },
          editButtonContainer: {
            alignItems: 'center',
            display: 'flex',
          },
          editText: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            margin: `0 ${Layout.space.xs}`,
          },
          header: {
            margin: `${Layout.space.md} 0`,
          },
          label: {
            height: Layout.space.md,
            margin: `0 0 ${Layout.space.md} 0`,
          },
          tenantUserSkillTags: {
            margin: `${Layout.space.md} 0 0`,
            maxHeight: '80px',
            overflowX: 'none',
            overflowY: 'scroll',
            width: '100%',
          },
          top: {
            height: 'fit-content',
            width: '100%',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.editText,
        {
          color: this.color.dark2(),
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getDescriptionStyle: function () {
        return this.isOthers
          ? {
          }
          : {
            backgroundColor: this.isOthers ? 'none' : this.color.shadow1(),
            borderRadius: Layout.space.xs,
            fontWeight: FontStyle.weight.lg,
            padding: Layout.space.md,
          }
      },
      isOthers: function () {
        return this.surveyCategorySkill.id < 0;
      },
      owned: function () {
        return this.ownedSkillIds.includes(this.surveyCategorySkill?.skill?.id);
      },
      skillName: function () {
        return this.surveyCategorySkill?.skill?.name;
      },
      surveyCategoryName: function () {
        return this.surveyCategorySkill?.surveyCategory?.name;
      },
      surveyCategorySkillName: function () {
        return this.surveyCategorySkill?.name
          ? this.surveyCategorySkill?.name
          : this.surveyCategorySkill?.skill?.name;
      },
      surveyCategorySkillDescription: function () {
        return (
          this.surveyCategorySkill?.description
            ? this.surveyCategorySkill.description
            : ''
        );
      },
      tenantUserSkillItems: function () {
        return this.tenantUserSkills
          .map(
            elem => {
              return {
                ...elem,
                'label': elem.skill.name,
              };
            }
          );
      },
    },
    methods: {
      onSelectTenantUserSkill: function (index) {
        this.$emit('select-tenant-user-skill', this.tenantUserSkills[index]);
      },
      onUnselectTenantUserSkill: function (index) {
        this.$emit('unselect-tenant-user-skill', this.tenantUserSkills[index]);
      },
      updateCategorizedTenantUserSkillIds: function () {
        const surveyCategoryId = this.surveyCategorySkill.surveyCategory.id;
        this.categorizedTenantUserSkillIds = this.surveyCategoryTenantUserSkills
          .filter(elem => elem.surveyCategory.id === surveyCategoryId)
          .map(elem => elem.tenantUserSkill.id);
      },
    },
    watch: {
      'surveyCategorySkill.surveyCategory.id': function (newVal, oldVal) {
        this.updateCategorizedTenantUserSkillIds();
      },
      surveyCategoryTenantUserSkills: {
        handler: function (newVal, oldVal) {
          this.updateCategorizedTenantUserSkillIds();
        },
        deep: true,
      },
    },
  };
</script>
